import React, { createContext, useContext } from 'react';
import defaultTheme from '../defaultTheme';
export const ThemeContext = createContext(defaultTheme);
export const ThemeProvider = ({ theme, children }) => (React.createElement(ThemeContext.Provider, { value: theme }, children));
//  use only with legacy components (classes) which don't support hooks
export const withTheme = (Component) => React.forwardRef((props, ref) => (React.createElement(ThemeContext.Consumer, null, (theme) => React.createElement(Component, { ...props, theme: theme, ref: ref }))));
const useTheme = () => useContext(ThemeContext);
export default useTheme;
//# sourceMappingURL=index.js.map